import { render, staticRenderFns } from "./Inscriptions-tipo-pago-comp.vue?vue&type=template&id=a920fb7a&scoped=true&"
import script from "./Inscriptions-tipo-pago-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-tipo-pago-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a920fb7a",
  null
  
)

export default component.exports